module.exports = __webpack_public_path__ + "static/img/row-right.97bdbf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/row-right.png
// module id = l1sB
// module chunks = 12